import {NewviewOaBaseApi} from "./NewviewOaBaseApi";


export class MaterialOutstoreItemApi extends NewviewOaBaseApi {

  public get ControllerName(): any {
    return 'materialOutstoreItem'
  }

}